//import axios from "axios";
import { QueryFunctionContext } from '@tanstack/react-query';
import { FindingContent, MeasurementResult, MeasurementResultValue, MeasurementResultValueForUpdate } from "./type";

let lastResults : { 
  lastMeasQuery: MeasurementResult[] | null, 
  lastFindingQuery: FindingContent[] | null
} = {lastMeasQuery : null, lastFindingQuery : null};

// for measurement
export const getMeasuremetResults = async (context: QueryFunctionContext): Promise<MeasurementResult[]> => {
  //const res = await axios.get("https://jsonplaceholder.typicode.com/posts");
  //return res.data;

  performance.mark('meas_data_begin');
  let measresults = new Array<MeasurementResult>();
  [...Array(context.meta?.numBlocks).keys()].forEach(elem => {
    [...Array(context.meta?.numParams).keys()].forEach(subelem => {
        let param : MeasurementResult= {
            paramCode: 'param_'+elem+'_'+subelem,
            innerParamID: 'param_'+elem+'_'+subelem,
            methodAndValue: {method: 'last',value: ''},
            eachResultValues: [...Array(context.meta?.numResults).keys()].map(resultnum => {
              let resval : MeasurementResultValue = {
                paramCode: 'param_'+elem+'_'+subelem,
                innerParamID: 'param_'+elem+'_'+subelem,
                measInsUID: 'meas_'+elem+'_'+subelem+'_'+resultnum,
                value: ''+(Math.random()*100).toFixed(2),
                modifiedValue: null,
                isDeleted: false,
              };
              return resval;              
            })
        };
        measresults.push(param);
    });
  });
  performance.mark('meas_data_end');
  performance.measure(
    'meas_data',
    'meas_data_begin',
    'meas_data_end',
  );
  const perfMeas = performance.getEntriesByName('meas_data');
  console.log('measurement generation times (ms)' + perfMeas[0].duration);

  lastResults.lastMeasQuery = measresults;
  return Promise.resolve(measresults);
};

export const updateMeasuremetResults = async (dataForUpdate : MeasurementResultValueForUpdate): Promise<MeasurementResult[] | null> => {
  if (lastResults.lastMeasQuery) {
    lastResults.lastMeasQuery.forEach(param => {
      param.eachResultValues.forEach(resval => {
        if (resval.measInsUID === dataForUpdate.measInsUID &&
            dataForUpdate.updateValue)
        {
          resval.modifiedValue = dataForUpdate.updateValue;
        }
      })
    })
  }
  return Promise.resolve(lastResults.lastMeasQuery);
}

// for findings
export const getFindings = async (context: QueryFunctionContext): Promise<FindingContent[]> => {
  //const res = await axios.get("https://jsonplaceholder.typicode.com/posts");
  //return res.data;

  performance.mark('finding_data_begin');
  let findings = new Array<FindingContent>();
  [...Array(context.meta?.numBlocks).keys()].forEach(elem => {
    let finding : FindingContent = {
      value: '' + elem,
    }
    findings.push(finding);
  });
  performance.mark('finding_data_end');
  performance.measure(
    'finding_data',
    'finding_data_begin',
    'finding_data_end',
  );
  const perfMeas = performance.getEntriesByName('finding_data');
  console.log('finding generation times (ms)' + perfMeas[0].duration);

  lastResults.lastFindingQuery = findings;
  return Promise.resolve(findings);
};